import React, { useEffect } from 'react';
import { useField } from 'formik';
import { MapContainer, TileLayer, GeoJSON, useMap } from 'react-leaflet';
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Passt den Kartenausschnitt automatisch an die Geometrie an
function FitBoundsToGeoJSON({ data }) {
    const map = useMap();
    useEffect(() => {
        try {
            const layer = L.geoJSON(data);
            const bounds = layer.getBounds();
            if (bounds.isValid()) {
                map.fitBounds(bounds, { padding: [20, 20], maxZoom: 18 });
            }
        } catch (e) {
            // ungültige Geometrie — Karte bleibt auf Default-Ansicht
        }
    }, [data, map]);
    return null;
}

export function GeometryMapField({ name }) {
    const [field] = useField(name);

    let geoJsonData = null;
    if (field.value) {
        try {
            geoJsonData = JSON.parse(field.value);
        } catch (e) {
            // kein gültiges GeoJSON
        }
    }

    return (
        <div style={{ width: '100%' }}>
            <div style={{
                fontSize: '12px',
                color: 'rgba(0,0,0,0.6)',
                marginBottom: '6px',
                paddingLeft: '2px',
                fontFamily: 'poppins',
                letterSpacing: '0.4px',
            }}>
                Geometrie (EPSG:4326)
            </div>

            <div style={{
                position: 'relative',
                width: '400px',
                height: '200px',
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1.5px solid rgba(0, 0, 0, 0.23)',
            }}>
                <MapContainer
                    center={[51.1657, 10.4515]}
                    zoom={5}
                    style={{ width: '100%', height: '100%' }}
                    scrollWheelZoom={false}
                    attributionControl={true}
                >
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a>'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {geoJsonData && (
                        <>
                            <GeoJSON
                                key={field.value}
                                data={geoJsonData}
                                pathOptions={{
                                    color: '#1565C0',
                                    weight: 2.5,
                                    fillColor: '#42A5F5',
                                    fillOpacity: 0.25,
                                }}
                            />
                            <FitBoundsToGeoJSON data={geoJsonData} />
                        </>
                    )}
                </MapContainer>

                {!geoJsonData && (
                    <div style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 999,
                        background: 'rgba(240, 244, 248, 0.82)',
                        fontSize: '13px',
                        color: '#6B7A8D',
                        pointerEvents: 'none',
                        fontFamily: 'poppins',
                        gap: '6px',
                    }}>
                        <span style={{ fontSize: '16px', opacity: 0.5 }}>📍</span>
                        Keine Geometrie vorhanden
                    </div>
                )}
            </div>

            {/* Verstecktes Formik-Feld — hält den Wert im Formular */}
            <input type="hidden" name={field.name} value={field.value || ''} onChange={field.onChange} onBlur={field.onBlur} />
        </div>
    );
}
